import { Credit } from '../types';
import { useGetCredits } from './use-get-credits';

export const useCreditsData = (): Credit[] => {
  const creditsQuery = useGetCredits();

  if (creditsQuery.isLoading || creditsQuery.isError) {
    return [];
  }

  return creditsQuery.data?.data || [];
};
